import React from 'react';

export const name = 'home';
export const Home = () => (
  <svg
    viewBox="0 0 18 18"
    fill="none"
    color="#6C717C"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.4041 15.5025H10.6566V10.6931H7.37157L7.3772 15.5025H2.59595V7.50375L9.02532 2.4975L15.4041 7.50375V15.5025Z"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeLinejoin="round"
    />
  </svg>
);
